import React, { useContext, useEffect, useState } from 'react'
import { DefectContext } from './SingleDefect'
import { DetailRow } from '../../../../components/Cards/DetailsBox'
import { Autocomplete, Box, Select, TextField } from '@mui/material'
import API from '../../../../services/API'

const Vehicle = () => {
  const { defect, setDefect, setChangesPresent } = useContext(DefectContext)
  const [vehicleOptions, setVehicleOptions] = useState([])

  useEffect(() => {
    API.get('/vehicleList')
      .then((res) => res.status === 200 && setVehicleOptions(res.data))
      .catch((e) => console.log(e))
  }, [])
  return (
    <DetailRow label="Vehicle" noBorder>
      <Autocomplete
        fullWidth
        value={defect.vehicle ?? null}
        options={vehicleOptions}
        renderInput={(params) => (
          <TextField {...params} size="small" fullWidth />
        )}
        getOptionKey={(opt) => opt._id}
        getOptionLabel={(opt) => opt.callSign}
        isOptionEqualToValue={(opt, val) => opt._id === val._id}
        onChange={(e, value) => {
          setDefect((props) => ({
            ...props,
            vehicle: value,
          }))
          setChangesPresent(true)
        }}
      />
    </DetailRow>
  )
}

export default Vehicle
